import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import { add } from 'date-fns';
import { A } from '@ember/array';

export default class TrackIsPlaying extends Helper {
  @service stereo;
  @service store;

  trackEnd(track, nextTrack) {
    if (track.duration) {
      return add(track.playedAt, { seconds: parseInt(track.duration, 10) });
    } else if (nextTrack) {
      return nextTrack.playedAt;
    } else {
      return false;
    }
  }

  computeValue(track, nextTrack) {
    try {
      if (
        this.stereo.isPlaying &&
        track &&
        this.stereo.currentSound &&
        this.stereo.currentSound.metadata.airing?.id ===
          track.belongsTo('airing').id()
      ) {
        if (!nextTrack) {
          let airing = this.store.peekRecord(
            'airing',
            track.belongsTo('airing').id()
          );
          let index = airing.items.findIndex((t) => t.id == track.id);
          let nextIndex = index + 1;
          if (airing.items.length >= nextIndex) {
            nextTrack = airing.items[index + 1];
          }
        }

        let trackEnd = this.trackEnd(track, nextTrack);
        let currentTime = this.stereo.currentSound.currentTime;
        let calculatedTime =
          track.airing.startsAt.getTime() + this.stereo.currentSound.position;

        let time = Math.max(
          ...A([currentTime?.getTime(), calculatedTime]).compact()
        );

        return (
          trackEnd &&
          time > track.playedAt.getTime() &&
          time < trackEnd.getTime()
        );
      }
    } catch (e) {
      //no op
    }

    return false;
  }

  compute([track, nextTrack]) {
    // let t0 = performance.now();
    let value = this.computeValue(track, nextTrack);
    // let t1 = performance.now();
    // console.log(`track-is-playing: ${t1 - t0} milliseconds.`);

    return value;
  }
}
